import { render } from "./LocaleComponent.vue?vue&type=template&id=2f1fdfa7&scoped=true"
import script from "./LocaleComponent.vue?vue&type=script&lang=js"
export * from "./LocaleComponent.vue?vue&type=script&lang=js"

import "./LocaleComponent.vue?vue&type=style&index=0&id=2f1fdfa7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f1fdfa7"]])

export default __exports__